import {
  CraftnoteEvent,
  createCraftnoteEventBuilder,
  GlobalCraftnoteEventParameters
} from "./CraftnoteEvent.generated";
/**
* Container for all events for Files
*
*
* this file was auto-generated Craftnote Events Code Generator, for more info visit: https://github.com/craftnote/craftnote-events
*/
export type FilesParameters = FilesFileSelectedParameters | FilesFileCopytoappspaceSucceededParameters | FilesFileCopytoappspaceFailedParameters | FilesFileLocalcreationSucceededParameters | FilesFileLocalcreationFailedParameters | FilesFileUploadqueuingSucceededParameters | FilesFileUploadqueuingFailedParameters | FilesFileUploadSucceededParameters | FilesFileUploadFailedParameters | FilesFileCreatedParameters | FilesFolderCreatedParameters | FilesFileDeletedParameters | FilesFileCopiedParameters | FilesFileForwardedParameters | FilesFileMovedParameters;
export type FilesEvents = FilesFileSelectedEvent | FilesFileCopytoappspaceSucceededEvent | FilesFileCopytoappspaceFailedEvent | FilesFileLocalcreationSucceededEvent | FilesFileLocalcreationFailedEvent | FilesFileUploadqueuingSucceededEvent | FilesFileUploadqueuingFailedEvent | FilesFileUploadSucceededEvent | FilesFileUploadFailedEvent | FilesFileCreatedEvent | FilesFolderCreatedEvent | FilesFileDeletedEvent | FilesFileCopiedEvent | FilesFileForwardedEvent | FilesFileMovedEvent;

export interface FilesFileSelectedParameters {
	version: string; // Version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	fileId: string; // ID of the current file being uploaded
	source: string; // source of the action, possible values are "camera", "storage", "scanner", "share", "pdf-editor", "photo-editor", "external"
	context: string; // context of the file selection, possible values are "chat", "project-files", "task-files"
}

export type FilesFileSelectedParametersSpecific = Omit<
	FilesFileSelectedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const filesFileSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class FilesFileSelectedEventBuilder {
	constructor(private specificParameters: FilesFileSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<FilesFileSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			FilesFileSelectedParametersSpecific,
            FilesFileSelectedParameters,
			(params: FilesFileSelectedParameters) => FilesFileSelectedEvent
		>(this.specificParameters, filesFileSelectedParametersGlobal, globalParams, (params) => new FilesFileSelectedEvent(params));
	}
}

/**
 * A user has selected a file for upload.
 */
export class FilesFileSelectedEvent extends CraftnoteEvent<FilesFileSelectedParameters>{
  constructor(parameters: FilesFileSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "craftnote",
			eventName: "files_file_selected"
		},
	]);
  }
}
export interface FilesFileCopytoappspaceSucceededParameters {
	version: string; // Version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	fileId: string; // ID of the current file being uploaded
}

export type FilesFileCopytoappspaceSucceededParametersSpecific = Omit<
	FilesFileCopytoappspaceSucceededParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const filesFileCopytoappspaceSucceededParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class FilesFileCopytoappspaceSucceededEventBuilder {
	constructor(private specificParameters: FilesFileCopytoappspaceSucceededParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<FilesFileCopytoappspaceSucceededParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			FilesFileCopytoappspaceSucceededParametersSpecific,
            FilesFileCopytoappspaceSucceededParameters,
			(params: FilesFileCopytoappspaceSucceededParameters) => FilesFileCopytoappspaceSucceededEvent
		>(this.specificParameters, filesFileCopytoappspaceSucceededParametersGlobal, globalParams, (params) => new FilesFileCopytoappspaceSucceededEvent(params));
	}
}

/**
 * A file was copied successfully to app space.
 */
export class FilesFileCopytoappspaceSucceededEvent extends CraftnoteEvent<FilesFileCopytoappspaceSucceededParameters>{
  constructor(parameters: FilesFileCopytoappspaceSucceededParameters){
	super(parameters);
	this.setProviders([
		{
			name: "craftnote",
			eventName: "files_file_copytoappspace_succeeded"
		},
	]);
  }
}
export interface FilesFileCopytoappspaceFailedParameters {
	version: string; // Version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	fileId: string; // ID of the current file being uploaded
}

export type FilesFileCopytoappspaceFailedParametersSpecific = Omit<
	FilesFileCopytoappspaceFailedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const filesFileCopytoappspaceFailedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class FilesFileCopytoappspaceFailedEventBuilder {
	constructor(private specificParameters: FilesFileCopytoappspaceFailedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<FilesFileCopytoappspaceFailedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			FilesFileCopytoappspaceFailedParametersSpecific,
            FilesFileCopytoappspaceFailedParameters,
			(params: FilesFileCopytoappspaceFailedParameters) => FilesFileCopytoappspaceFailedEvent
		>(this.specificParameters, filesFileCopytoappspaceFailedParametersGlobal, globalParams, (params) => new FilesFileCopytoappspaceFailedEvent(params));
	}
}

/**
 * A copy of a file to app space failed.
 */
export class FilesFileCopytoappspaceFailedEvent extends CraftnoteEvent<FilesFileCopytoappspaceFailedParameters>{
  constructor(parameters: FilesFileCopytoappspaceFailedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "craftnote",
			eventName: "files_file_copytoappspace_failed"
		},
	]);
  }
}
export interface FilesFileLocalcreationSucceededParameters {
	version: string; // Version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	fileId: string; // ID of the current file being uploaded
}

export type FilesFileLocalcreationSucceededParametersSpecific = Omit<
	FilesFileLocalcreationSucceededParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const filesFileLocalcreationSucceededParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class FilesFileLocalcreationSucceededEventBuilder {
	constructor(private specificParameters: FilesFileLocalcreationSucceededParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<FilesFileLocalcreationSucceededParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			FilesFileLocalcreationSucceededParametersSpecific,
            FilesFileLocalcreationSucceededParameters,
			(params: FilesFileLocalcreationSucceededParameters) => FilesFileLocalcreationSucceededEvent
		>(this.specificParameters, filesFileLocalcreationSucceededParametersGlobal, globalParams, (params) => new FilesFileLocalcreationSucceededEvent(params));
	}
}

/**
 * A local entry of the file being uploaded was generated.
 */
export class FilesFileLocalcreationSucceededEvent extends CraftnoteEvent<FilesFileLocalcreationSucceededParameters>{
  constructor(parameters: FilesFileLocalcreationSucceededParameters){
	super(parameters);
	this.setProviders([
		{
			name: "craftnote",
			eventName: "files_file_localcreation_succeeded"
		},
	]);
  }
}
export interface FilesFileLocalcreationFailedParameters {
	version: string; // Version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	fileId: string; // ID of the current file being uploaded
}

export type FilesFileLocalcreationFailedParametersSpecific = Omit<
	FilesFileLocalcreationFailedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const filesFileLocalcreationFailedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class FilesFileLocalcreationFailedEventBuilder {
	constructor(private specificParameters: FilesFileLocalcreationFailedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<FilesFileLocalcreationFailedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			FilesFileLocalcreationFailedParametersSpecific,
            FilesFileLocalcreationFailedParameters,
			(params: FilesFileLocalcreationFailedParameters) => FilesFileLocalcreationFailedEvent
		>(this.specificParameters, filesFileLocalcreationFailedParametersGlobal, globalParams, (params) => new FilesFileLocalcreationFailedEvent(params));
	}
}

/**
 * Creating a local entry of the file being uploaded failed.
 */
export class FilesFileLocalcreationFailedEvent extends CraftnoteEvent<FilesFileLocalcreationFailedParameters>{
  constructor(parameters: FilesFileLocalcreationFailedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "craftnote",
			eventName: "files_file_localcreation_failed"
		},
	]);
  }
}
export interface FilesFileUploadqueuingSucceededParameters {
	version: string; // Version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	fileId: string; // ID of the current file being uploaded
}

export type FilesFileUploadqueuingSucceededParametersSpecific = Omit<
	FilesFileUploadqueuingSucceededParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const filesFileUploadqueuingSucceededParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class FilesFileUploadqueuingSucceededEventBuilder {
	constructor(private specificParameters: FilesFileUploadqueuingSucceededParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<FilesFileUploadqueuingSucceededParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			FilesFileUploadqueuingSucceededParametersSpecific,
            FilesFileUploadqueuingSucceededParameters,
			(params: FilesFileUploadqueuingSucceededParameters) => FilesFileUploadqueuingSucceededEvent
		>(this.specificParameters, filesFileUploadqueuingSucceededParametersGlobal, globalParams, (params) => new FilesFileUploadqueuingSucceededEvent(params));
	}
}

/**
 * A file is queued for upload after a local entry was created.
 */
export class FilesFileUploadqueuingSucceededEvent extends CraftnoteEvent<FilesFileUploadqueuingSucceededParameters>{
  constructor(parameters: FilesFileUploadqueuingSucceededParameters){
	super(parameters);
	this.setProviders([
		{
			name: "craftnote",
			eventName: "files_file_uploadqueuing_succeeded"
		},
	]);
  }
}
export interface FilesFileUploadqueuingFailedParameters {
	version: string; // Version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	fileId: string; // ID of the current file being uploaded
}

export type FilesFileUploadqueuingFailedParametersSpecific = Omit<
	FilesFileUploadqueuingFailedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const filesFileUploadqueuingFailedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class FilesFileUploadqueuingFailedEventBuilder {
	constructor(private specificParameters: FilesFileUploadqueuingFailedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<FilesFileUploadqueuingFailedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			FilesFileUploadqueuingFailedParametersSpecific,
            FilesFileUploadqueuingFailedParameters,
			(params: FilesFileUploadqueuingFailedParameters) => FilesFileUploadqueuingFailedEvent
		>(this.specificParameters, filesFileUploadqueuingFailedParametersGlobal, globalParams, (params) => new FilesFileUploadqueuingFailedEvent(params));
	}
}

/**
 * Queuing a file for upload has failed.
 */
export class FilesFileUploadqueuingFailedEvent extends CraftnoteEvent<FilesFileUploadqueuingFailedParameters>{
  constructor(parameters: FilesFileUploadqueuingFailedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "craftnote",
			eventName: "files_file_uploadqueuing_failed"
		},
	]);
  }
}
export interface FilesFileUploadSucceededParameters {
	version: string; // Version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	fileId: string; // ID of the current file being uploaded
}

export type FilesFileUploadSucceededParametersSpecific = Omit<
	FilesFileUploadSucceededParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const filesFileUploadSucceededParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class FilesFileUploadSucceededEventBuilder {
	constructor(private specificParameters: FilesFileUploadSucceededParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<FilesFileUploadSucceededParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			FilesFileUploadSucceededParametersSpecific,
            FilesFileUploadSucceededParameters,
			(params: FilesFileUploadSucceededParameters) => FilesFileUploadSucceededEvent
		>(this.specificParameters, filesFileUploadSucceededParametersGlobal, globalParams, (params) => new FilesFileUploadSucceededEvent(params));
	}
}

/**
 * A file was uploaded successfully.
 */
export class FilesFileUploadSucceededEvent extends CraftnoteEvent<FilesFileUploadSucceededParameters>{
  constructor(parameters: FilesFileUploadSucceededParameters){
	super(parameters);
	this.setProviders([
		{
			name: "craftnote",
			eventName: "files_file_upload_succeeded"
		},
	]);
  }
}
export interface FilesFileUploadFailedParameters {
	version: string; // Version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	fileId: string; // ID of the current file being uploaded
}

export type FilesFileUploadFailedParametersSpecific = Omit<
	FilesFileUploadFailedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const filesFileUploadFailedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class FilesFileUploadFailedEventBuilder {
	constructor(private specificParameters: FilesFileUploadFailedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<FilesFileUploadFailedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			FilesFileUploadFailedParametersSpecific,
            FilesFileUploadFailedParameters,
			(params: FilesFileUploadFailedParameters) => FilesFileUploadFailedEvent
		>(this.specificParameters, filesFileUploadFailedParametersGlobal, globalParams, (params) => new FilesFileUploadFailedEvent(params));
	}
}

/**
 * Uploading a file failed.
 */
export class FilesFileUploadFailedEvent extends CraftnoteEvent<FilesFileUploadFailedParameters>{
  constructor(parameters: FilesFileUploadFailedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "craftnote",
			eventName: "files_file_upload_failed"
		},
	]);
  }
}
export interface FilesFileCreatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
	mimeType: string; // MIME type of the uploaded file
	source: string; // source of the action, possible values are "camera", "storage", "scanner", "share", "pdf-editor", "photo-editor"
	fileId: string; // ID of the created file
}

export type FilesFileCreatedParametersSpecific = Omit<
	FilesFileCreatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const filesFileCreatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class FilesFileCreatedEventBuilder {
	constructor(private specificParameters: FilesFileCreatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<FilesFileCreatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			FilesFileCreatedParametersSpecific,
            FilesFileCreatedParameters,
			(params: FilesFileCreatedParameters) => FilesFileCreatedEvent
		>(this.specificParameters, filesFileCreatedParametersGlobal, globalParams, (params) => new FilesFileCreatedEvent(params));
	}
}

/**
 * A user uploaded a file to the files section.
 */
export class FilesFileCreatedEvent extends CraftnoteEvent<FilesFileCreatedParameters>{
  constructor(parameters: FilesFileCreatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "add_data_in_files"
		},
		{
			name: "iterable",
			eventName: "files_file_created"
		},
	]);
  }
}
export interface FilesFolderCreatedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
	folderId: string; // ID of the created folder
}

export type FilesFolderCreatedParametersSpecific = Omit<
	FilesFolderCreatedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const filesFolderCreatedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class FilesFolderCreatedEventBuilder {
	constructor(private specificParameters: FilesFolderCreatedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<FilesFolderCreatedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			FilesFolderCreatedParametersSpecific,
            FilesFolderCreatedParameters,
			(params: FilesFolderCreatedParameters) => FilesFolderCreatedEvent
		>(this.specificParameters, filesFolderCreatedParametersGlobal, globalParams, (params) => new FilesFolderCreatedEvent(params));
	}
}

/**
 * A user created a new folder in the files section.
 */
export class FilesFolderCreatedEvent extends CraftnoteEvent<FilesFolderCreatedParameters>{
  constructor(parameters: FilesFolderCreatedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "add_folder_in_files"
		},
		{
			name: "iterable",
			eventName: "files_folder_created"
		},
	]);
  }
}
export interface FilesFileDeletedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
	fileId: string; // ID of the deleted file
}

export type FilesFileDeletedParametersSpecific = Omit<
	FilesFileDeletedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const filesFileDeletedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class FilesFileDeletedEventBuilder {
	constructor(private specificParameters: FilesFileDeletedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<FilesFileDeletedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			FilesFileDeletedParametersSpecific,
            FilesFileDeletedParameters,
			(params: FilesFileDeletedParameters) => FilesFileDeletedEvent
		>(this.specificParameters, filesFileDeletedParametersGlobal, globalParams, (params) => new FilesFileDeletedEvent(params));
	}
}

/**
 * A user deleted a file from the files section.
 */
export class FilesFileDeletedEvent extends CraftnoteEvent<FilesFileDeletedParameters>{
  constructor(parameters: FilesFileDeletedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "delete_data_in_files"
		},
		{
			name: "iterable",
			eventName: "files_file_deleted"
		},
	]);
  }
}
export interface FilesFileCopiedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
}

export type FilesFileCopiedParametersSpecific = Omit<
	FilesFileCopiedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const filesFileCopiedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class FilesFileCopiedEventBuilder {
	constructor(private specificParameters: FilesFileCopiedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<FilesFileCopiedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			FilesFileCopiedParametersSpecific,
            FilesFileCopiedParameters,
			(params: FilesFileCopiedParameters) => FilesFileCopiedEvent
		>(this.specificParameters, filesFileCopiedParametersGlobal, globalParams, (params) => new FilesFileCopiedEvent(params));
	}
}

/**
 * A user created a copy of a file. If multiple files are copied, multiple events will be triggered.
 */
export class FilesFileCopiedEvent extends CraftnoteEvent<FilesFileCopiedParameters>{
  constructor(parameters: FilesFileCopiedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "files_copyData_succeeded"
		},
		{
			name: "iterable",
			eventName: "files_file_copied"
		},
	]);
  }
}
export interface FilesFileForwardedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	sourceProjectId: string; // ID of the source project
	destinationProjectId: string; // ID of the destination project
	target: string; // target context of the forward operation, can be any of "files", "chat"
}

export type FilesFileForwardedParametersSpecific = Omit<
	FilesFileForwardedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const filesFileForwardedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class FilesFileForwardedEventBuilder {
	constructor(private specificParameters: FilesFileForwardedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<FilesFileForwardedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			FilesFileForwardedParametersSpecific,
            FilesFileForwardedParameters,
			(params: FilesFileForwardedParameters) => FilesFileForwardedEvent
		>(this.specificParameters, filesFileForwardedParametersGlobal, globalParams, (params) => new FilesFileForwardedEvent(params));
	}
}

/**
 * A user forwarded a file. If multiple files are forwarded, multiple events will be triggered.
 */
export class FilesFileForwardedEvent extends CraftnoteEvent<FilesFileForwardedParameters>{
  constructor(parameters: FilesFileForwardedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "files_forwardDataChat_succeeded"
		},
		{
			name: "iterable",
			eventName: "files_file_forwarded"
		},
	]);
  }
}
export interface FilesFileMovedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	projectId: string; // ID of the affected project
	type: string; // type, either "file" or "folder"
}

export type FilesFileMovedParametersSpecific = Omit<
	FilesFileMovedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const filesFileMovedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class FilesFileMovedEventBuilder {
	constructor(private specificParameters: FilesFileMovedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<FilesFileMovedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			FilesFileMovedParametersSpecific,
            FilesFileMovedParameters,
			(params: FilesFileMovedParameters) => FilesFileMovedEvent
		>(this.specificParameters, filesFileMovedParametersGlobal, globalParams, (params) => new FilesFileMovedEvent(params));
	}
}

/**
 * A user moved a file or folder into another folder. If multiple files/folders are moved, multiple events will be triggered.
 */
export class FilesFileMovedEvent extends CraftnoteEvent<FilesFileMovedParameters>{
  constructor(parameters: FilesFileMovedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "files_moveData_succeeded"
		},
		{
			name: "iterable",
			eventName: "files_file_moved"
		},
	]);
  }
}
